import axios from "axios";
const setApiUrl = () => (axios.defaults.baseURL = `${process.env.REACT_APP_BACKEND_SERVER}/api/v1`);
export default setApiUrl;
